import { selector } from 'recoil';
import { allValid, validateSchema } from '@zurich/common/recoil';
import { partyBankAccountBicSchema, partyBankAccountBicSchemaRequired, partyBankAccountHolderSchema, partyBankAccountIbanSchema, partyBankAccountNameSchema, } from '../../forms';
import { localPartyBankAccountBicSelector, localPartyBankAccountHolderSelector, localPartyBankAccountIbanSelector, localPartyBankAccountNameSelector, } from '../selectors/localPartyBankAccount';
export const localPartyBankAccountNameValidationSelector = selector({
    key: 'validation/local/partyBankAccountName',
    get: ({ get }) => validateSchema(partyBankAccountNameSchema, get(localPartyBankAccountNameSelector)),
});
export const localPartyBankAccountHolderValidationSelector = selector({
    key: 'validation/local/partyBankAccountHolder',
    get: ({ get }) => validateSchema(partyBankAccountHolderSchema, get(localPartyBankAccountHolderSelector)),
});
export const localPartyBankAccountIbanValidationSelector = selector({
    key: 'validation/local/partyBankAccountIban',
    get: ({ get }) => validateSchema(partyBankAccountIbanSchema, get(localPartyBankAccountIbanSelector)),
});
export const localPartyBankAccountBicValidationSelector = selector({
    key: 'validation/local/partyBankAccountBic',
    get: ({ get }) => {
        const bic = get(localPartyBankAccountBicSelector);
        const iban = get(localPartyBankAccountIbanSelector);
        const isATIban = iban?.slice(0, 2) === 'AT';
        return validateSchema(isATIban ? partyBankAccountBicSchema : partyBankAccountBicSchemaRequired, bic);
    },
});
export const updateBankAccountFormValidationSelector = selector({
    key: 'validation/local/partyBankAccountForm',
    get: ({ get }) => allValid({
        partyBankAccountName: get(localPartyBankAccountNameValidationSelector),
        partyBankAccountHolder: get(localPartyBankAccountHolderValidationSelector),
        partyBankAccountIban: get(localPartyBankAccountIbanValidationSelector),
        partyBankAccountBic: get(localPartyBankAccountBicValidationSelector),
    }),
});
